var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.isEditing
        ? _c("TextField", {
            staticClass: "small-6 medium-6 large-6 signature",
            attrs: {
              label: _vm.label,
              value: _vm.content,
              showColon: false,
              readonly: !_vm.isEditing,
              required: _vm.isEditing,
              defaultEmpty: "",
            },
            on: { updateValue: _vm.updateContent },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "small-6 medium-6 large-6 preview" }, [
        _c("label", { staticClass: "title" }, [
          _vm._v(
            _vm._s(_vm.label) +
              " " +
              _vm._s(_vm.isEditing ? _vm.$t("action.preview") : "")
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          key: _vm.previewKey || new Date().getTime(),
          staticClass: "clearfix content",
          domProps: { innerHTML: _vm._s(_vm.content) },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }